import { trans } from "@mongez/localization";
import { createPortal } from "core/shared";
import { Portal } from "~/modules/shared/components/Portal";
import { RequestCustomCakesSteps } from "./components";

export const requestCustomCakesPortal = createPortal(
  "request-custom-cakes-portal",
);

export function RequestCutomCakesPortal() {
  return (
    <Portal
      classes={{
        content: "w-[80%]",
      }}
      portal={requestCustomCakesPortal}
      title={trans("requestCustomCakes")}
    >
      <div className="flex flex-col gap-11">
        <p className="text-night/75 font-avenir text-sm sm:text-base lg:text-lg 2xl:text-xl">
          {trans("weLoveOccasions")}
        </p>
        <RequestCustomCakesSteps />
      </div>
    </Portal>
  );
}
